import { EnvName, endpointConfig } from './configuration';

const DEFAULT_DEBOUNCE_MS = 1500;

export const isDevOrLocalEnv = () => {
    return endpointConfig.env.DEPLOY_ENV === EnvName.DEV;
};

export const isIntEnv = () => {
    return endpointConfig.env.DEPLOY_ENV === EnvName.INT;
};

export const isProdEnv = () => {
    return endpointConfig.env.DEPLOY_ENV === EnvName.PROD;
};

export const currentEnv = endpointConfig.env.DEPLOY_ENV;

export const getUmasLink = () => {
    return endpointConfig.env.UMAS_LINK;
};

function parsePositiveInt(value?: string): number | null {
    if (!value) {
        return null;
    }
    const n = Number(value);
    if (!Number.isFinite(n) || n < 0) {
        return null;
    }
    return Math.floor(n);
}

export const getSearchDebounceMs = (): number => {
    // value come from process.env (DEV) or token replacement (PROD)
    const raw = endpointConfig.env.SEARCH_DEBOUNCE_MS;
    return parsePositiveInt(raw) ?? DEFAULT_DEBOUNCE_MS;
};
